/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerFindOneQueryResponse, ArtifactsControllerFindOnePathParams, ArtifactsControllerFindOneQueryParams, ArtifactsControllerFindOne400, ArtifactsControllerFindOne401, ArtifactsControllerFindOne403, ArtifactsControllerFindOne404 } from "../../models/documentArtifactsController/ArtifactsControllerFindOne";

function getArtifactsControllerFindOneUrl(documentId: ArtifactsControllerFindOnePathParams["documentId"], renditionId: ArtifactsControllerFindOnePathParams["renditionId"], artifactId: ArtifactsControllerFindOnePathParams["artifactId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${documentId}/renditions/${renditionId}/artifacts/${artifactId}` as const }  
  return res
}

/**
 * @description Returns a specific artifact by its ID
 * @summary Get a specific artifact
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId}
 */
export async function artifactsControllerFindOne(documentId: ArtifactsControllerFindOnePathParams["documentId"], renditionId: ArtifactsControllerFindOnePathParams["renditionId"], artifactId: ArtifactsControllerFindOnePathParams["artifactId"], params?: ArtifactsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ArtifactsControllerFindOneQueryResponse, ResponseErrorConfig<ArtifactsControllerFindOne400 | ArtifactsControllerFindOne401 | ArtifactsControllerFindOne403 | ArtifactsControllerFindOne404>, unknown>({ method : "GET", url : getArtifactsControllerFindOneUrl(documentId, renditionId, artifactId).url.toString(), params, ... requestConfig })  
  return res.data
}